import { locale as en } from './en';
import { locale as pt } from './pt';
import { locale as es } from './es';

export const locales = [en, pt, es];
